export default __webpack_public_path__ + "static/media/budgetTracker.6dc94a96.PNG";